export class GerarBoletoCadastro {
    constructor(
        public valorPago: number,
        public dataVencimento: Date
    ) { }
}
